const actions = {
  CREATE_MEMBER_TAG_FILTER: 'CREATE_MEMBER_TAG_FILTER',
  CREATE_MEMBER_TAG_FILTER_ENDED: 'CREATE_MEMBER_TAG_FILTER_ENDED',
  SEARCH_MEMBER_TAG_FILTERS: 'SEARCH_MEMBER_TAG_FILTERS',
  SEARCH_MEMBER_TAG_FILTERS_ENDED: 'SEARCH_MEMBER_TAG_FILTERS_ENDED',
  FIND_MEMBER_TAG_FILTER: 'FIND_MEMBER_TAG_FILTER',
  FIND_MEMBER_TAG_FILTER_ENDED: 'FIND_MEMBER_TAG_FILTER_ENDED',
  UPDATE_MEMBER_TAG_FILTER: 'UPDATE_MEMBER_TAG_FILTER',
  UPDATE_MEMBER_TAG_FILTER_ENDED: 'UPDATE_MEMBER_TAG_FILTER_ENDED',
  DELETE_MEMBER_TAG_FILTERS: 'DELETE_MEMBER_TAG_FILTERS',
  DELETE_MEMBER_TAG_FILTERS_ENDED: 'DELETE_MEMBER_TAG_FILTERS_ENDED',
  TRIGGER_MEMBER_TAG_FILTER: 'TRIGGER_MEMBER_TAG_FILTER',
  TRIGGER_MEMBER_TAG_FILTER_ENDED: 'TRIGGER_MEMBER_TAG_FILTER_ENDED',
  SEARCH_MEMBER_TAG_FILTER_TRIGGER_RECORDS: 'SEARCH_MEMBER_TAG_FILTER_TRIGGER_RECORDS',
  SEARCH_MEMBER_TAG_FILTER_TRIGGER_RECORDS_ENDED: 'SEARCH_MEMBER_TAG_FILTER_TRIGGER_RECORDS_ENDED',
};

export default actions;
